import React from 'react';
import { statusStrategy } from '../statusStrategy';
import { StatusWrap } from './StatusWrap';
import { StatusIcon } from './StatusIcon';
import { StatusText } from './StatusText';

export default function QualificationStatus({ qualifiedStatus }) {
  const { icon, alt, message, color } = statusStrategy[qualifiedStatus];

  return (
    <StatusWrap>
      <StatusIcon src={icon} alt={alt} />
      <StatusText color={color}>{message}</StatusText>
    </StatusWrap>
  );
}
